module.exports = function() {
  return new Worker(__webpack_public_path__ + "4bfafe375e6f1117e697.worker.js");
};